/**
 * Created by rudi on 07/02/14.
 */

OLIVIO.LumData = function () {
  this.lumJointOffsetWorld = 0;
  var lumPositionWorld = 0;
  // front is 0, rotation is clockwise
  this.lumRotationCombined = 0;
  this.lumVisible = true;
  this.sideLumReload = false;
  this.product = '';
  this.lumType = '';
  this.bracketType = '';
  this.modelIndex = 0;

  this.colorFill = '#ffffff';
  this.colorOutline = '#000000';
  this.colorFillInlay = '#ffffff';
  this.colorOutlineInlay = '#000000';

  this.colorFillSelected = '#000000';
  this.colorOutlineSelected = '#ffffff';
  this.colorFillInlaySelected = '#000000';



  this.positionFromDraging = 0;
  this.positionBoundaryTopWorld = 0;
  this.positionBoundaryBottomWorld = 0;
  this.positionSnapToGroupTop = -1;
  this.positionSnapToGroupBottom = -1;
  this.rotationGroupMinDist = -1;
  this.rotationGroupCombinedRotations = [];

  this.groupId = -1;


  this.setLumPositionWorld = function (value) {
    lumPositionWorld = value;
  };

  this.getLumPositionWorld = function () {
    return lumPositionWorld;
  };

  this.setRotationWithStartMathematical = function (value) {
    // FIXME value has to be zero or negativ to activate if angle>=360
    var angle = 360-value;
    if (angle>=360) {
      angle-=360;
    }
    this.lumRotationCombined = angle;
  };

  this.getRotationWithStartMathematical = function () {
    var angle = 360-this.lumRotationCombined;
    if (angle>=360) {
      angle-=360;
    }
    return angle;
  };

  this.updateFromTypeChange = function () {
    //console.log('lumupdate: '+this.lumType+' '+this.bracketType);
    var oldLumJointOffsetWorld = this.lumJointOffsetWorld;

    if (this.product === OLIVIO.PRODUCT_SISTEMA) {
      if (this.lumType === OLIVIO.LUM_PICCOLO) {
        if (this.bracketType === OLIVIO.BRACKET_SISTEMA3) {
          //good
          this.lumJointOffsetWorld = 50;
        }
      } else if (this.lumType === OLIVIO.LUM_MEDIO) {
        if (this.bracketType === OLIVIO.BRACKET_SISTEMA1) {
          //good
          this.lumJointOffsetWorld = 35;
        } else if (this.bracketType === OLIVIO.BRACKET_SISTEMA2) {
          //good
          this.lumJointOffsetWorld = 45;
        } else if (this.bracketType === OLIVIO.BRACKET_SISTEMA3) {
          //good
          this.lumJointOffsetWorld = 25;
        }
      } else if (this.lumType === OLIVIO.LUM_GRANDE) {
        if (this.bracketType === OLIVIO.BRACKET_SISTEMA1) {
          //good
          this.lumJointOffsetWorld = 35;
        } else if (this.bracketType === OLIVIO.BRACKET_SISTEMA2) {
          this.lumJointOffsetWorld = 45;
        } else if (this.bracketType === OLIVIO.BRACKET_SISTEMA3) {
          //good
          this.lumJointOffsetWorld = 25;
        }
      }
    } else if (this.product === OLIVIO.PRODUCT_FLORACION) {
      //TODO check it
      this.lumJointOffsetWorld = 100;
    }
    if (oldLumJointOffsetWorld !== this.lumJointOffsetWorld) {
      this.setLumPositionWorld(this.getLumPositionWorld() - (this.lumJointOffsetWorld-oldLumJointOffsetWorld));
    }


  };
  this.getJointPositionWorld = function () {
    return lumPositionWorld + this.lumJointOffsetWorld;
  };

  this.setJointPositionWorld = function (value) {
    lumPositionWorld = value - this.lumJointOffsetWorld;
  };

};
